import { gql } from "@apollo/client";export default gql`mutation UpdateGroupDocumentMap($id: Int!, $_set: home_explore_group_document_map_set_input = {}) {
  update_home_explore_group_document_map_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
`;
